const scoreAddrule = () => import('@/views/main/score/add-rule/add-rule.vue')
export default {
  path: '/main/score/scoreAddrule',
  name: 'scoreAddrule',
  component:  scoreAddrule,
  children: []
}
